// extracted by mini-css-extract-plugin
export var news_title = "styles-module--news_title--3UC5n";
export var news_list = "styles-module--news_list--1XqeH";